export default __webpack_public_path__ + "static/media/guarm.893fd140.svg";